import { Injectable } from "@angular/core";

@Injectable()
export class DownloadService {

    constructor() {}

    /**Go to azure website to download a file */
    getFile(sectionId, reportId, studentId) {

        let parameters = `?sectionId=${sectionId}&reportId=${reportId}&studentId=${studentId}`;
        let azureUrl = 'https://rosymarti.azurewebsites.net/DocumentFactory/DescargarArchivo' + parameters;

        window.open(azureUrl);

    }

    getAllFilesBySectionId(sectionId: string, reportId: string) {
      let parameters = `?sectionId=${sectionId}&reportId=${reportId}`;
      let azureUrl = `https://rosymarti.azurewebsites.net/DocumentFactory/DescargarLibretasPorSeccion${parameters}`;
      //let azureUrl = `http://localhost:30965/DocumentFactory/DescargarLibretasPorSeccion${parameters}`;

      //console.log(azureUrl);
      window.open(azureUrl);
    }
}
